import css from "styled-jsx/css";

export const componentStyles = css`
    .items-list-component {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: -32px;
        justify-content: space-between;
        max-width: 760px;

        .item-wrapper {
            margin-bottom: 48px;
        }
    }
`;